<template>
    <auth-container>
        <h1 class="mb-12 text-center text-xl font-semibold">Anmelden</h1>
        <input-text
            class="mb-5 w-96"
            :name="'email'"
            :id="'email'"
            v-model="state.user.email"
            :label="'E-Mail'"
            :labelClass="'bg-white'"
        />
        <input-text
            class="mb-5 w-96"
            :name="'password'"
            :id="'password'"
            v-model="state.user.password"
            :label="'Passwort'"
            :labelClass="'bg-white'"
            :type="'password'"
            @enter="LOGIN(state.user)"
        />

        <custom-button
            @click="LOGIN(state.user)"
            class="w-96 h-11"
            :text="'Anmelden'"
            :bgColor="'bg-primary'"
            :textColor="'text-white'"
            :id="'login-button'"
        />
        <div class="text-red mt-5" v-if="state.errorMessage != null">
            {{ state.errorMessage }}
        </div>
        <router-link
            tag="h4"
            :to="{ name: 'PasswordReset' }"
            class="absolute bottom-5 cursor-pointer text-grey transition-colors hover:text-grey-dark"
        >
            Passwort vergessen
        </router-link>
    </auth-container>
</template>

<script>
import { defineComponent, reactive, onMounted } from "vue";
import CustomButton from "../../components/input/CustomButton.vue";
import InputText from "../../components/input/InputText.vue";
import { AUTH_TYPES, HELPER_TYPES, STORE_TYPES } from "../../store/types";

import { useStore } from "vuex";
import AuthContainer from "./helpers/AuthContainer.vue";
import { getData } from "../../common/dataHelper";
import { useRoute } from "vue-router";
export default defineComponent({
    name: "Login",
    components: { InputText, CustomButton, AuthContainer },
    setup() {
        const store = useStore();
        const state = reactive({
            user: {
                email: "",
                password: "",
                stay_logged_in: false,
                errorMessage: null,
            },
        });
        /**
         * functions
         */
        async function LOGIN(user) {
            store.commit(
                `${STORE_TYPES.HELPERS}/${HELPER_TYPES.SET_LOADING_ID}`,
                "login-button"
            );
            const response = await store.dispatch(
                `${STORE_TYPES.AUTH}/${AUTH_TYPES.LOGIN}`,
                {
                    user,
                }
            );
            store.commit(
                `${STORE_TYPES.HELPERS}/${HELPER_TYPES.REMOVE_LOADING_ID}`,
                "login-button"
            );

            // Check if email or password are wrong and save error to local state (used for display below login button)
            const passwordError = getData(
                    response,
                    "response.data.errors.password"
                ),
                emailError = getData(response, "response.data.errors.email");
            if (emailError != null || passwordError != null) {
                state.errorMessage = emailError
                    ? emailError[0]
                    : passwordError[0];
            } else {
                state.errorMessage = null;
            }
        }
        const route = useRoute();
        onMounted(async () => {
            console.log(route.query.token);
            const token = route.query.token;
            if (token) {
                const response = await store.dispatch(
                    `${STORE_TYPES.AUTH}/${AUTH_TYPES.LOGIN_WITH_TOKEN}`,
                    {
                        token,
                    }
                );
                console.log(response);
            }
        });

        return {
            state,
            LOGIN,
        };
    },
});
</script>

<style></style>
